import { render, staticRenderFns } from "./TableRiskAppraisal_5x4_miras.vue?vue&type=template&id=de4c5e9a&scoped=true"
import script from "./TableRiskAppraisal_5x4_miras.vue?vue&type=script&lang=js"
export * from "./TableRiskAppraisal_5x4_miras.vue?vue&type=script&lang=js"
import style0 from "./TableRiskAppraisal_5x4_miras.vue?vue&type=style&index=0&id=de4c5e9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de4c5e9a",
  null
  
)

export default component.exports